// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsAccountSaveUserSaveUserRequestModel {
    static getAttributeTypeMap() {
        return ScriptsAccountSaveUserSaveUserRequestModel.attributeTypeMap;
    }
}
ScriptsAccountSaveUserSaveUserRequestModel.discriminator = undefined;
ScriptsAccountSaveUserSaveUserRequestModel.attributeTypeMap = [
    {
        "name": "userName",
        "baseName": "userName",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "ScriptsAccountSaveUserSaveUserContactInfoRequestModel"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "ScriptsAccountSaveUserSaveUserContactInfoRequestModel"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "ScriptsAccountSaveUserSaveUserContactInfoRequestModel"
    }
];
//# sourceMappingURL=scriptsAccountSaveUserSaveUserRequestModel.js.map